import PropTypes from "prop-types"
import "./styles.scss"
import { chain } from "lodash"

export default function AssetsTableHeaderTooltipContents({ contents }) {
  const rows = chain(contents)
    .compact()
    .map(({ label, value }) => <div key={label}>
      <div>{label}:</div>
      <div>{value}</div>
    </div>)
    .value()

  return <div className="components_assets-table-header_tooltip-contents">
    {rows}
  </div>
}

AssetsTableHeaderTooltipContents.propTypes = {
  contents: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })),
}
